/**
 * SEC-006 — the public Supabase key the app is built with (browser bundle and the user-scoped server clients).
 *
 * `NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY` is the project's `default` publishable key (sb_publishable_…), set as the
 * Cloud Build trigger substitution `_NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY`. Public by design; grants only what RLS
 * allows. The legacy `NEXT_PUBLIC_SUPABASE_ANON_KEY` fallback was removed at P5 (legacy keys deactivated 2026-10-14).
 *
 * The `process.env.NEXT_PUBLIC_…` read is written out in full so Next.js inlines it at build time.
 */
export function getSupabasePublicKey(): string {
  const publishable = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY?.trim();
  if (publishable) return publishable;
  throw new Error('Supabase publishable key not configured (NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY)');
}
